module.exports = __webpack_public_path__ + "static/img/Aacteacher1.a935f4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aacteacher1.png
// module id = F2pA
// module chunks = 1